import { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
import { api, errorMessage } from './toetsUtils';

export default function StudentChoice({ value, selectedName = '', onChange, required = false, disabled = false, id = 'toets-student', searchValue, onSearchChange, allLabel = 'Alle leerlingen' }) {
  const { userInfo } = useAuth();
  const accessKey = `${userInfo?.user_id || ''}:${userInfo?.customer_id || ''}:${userInfo?.role || ''}:${(userInfo?.user_location_ids || []).join(',')}`;
  const [localSearch, setLocalSearch] = useState('');
  const search = searchValue === undefined ? localSearch : searchValue;
  const [debounced, setDebounced] = useState('');
  const [students, setStudents] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    const timer = setTimeout(() => { setDebounced(search.trim()); setPage(1); }, 300);
    return () => clearTimeout(timer);
  }, [search]);
  useEffect(() => {
    if (disabled) return undefined;
    const controller = new AbortController();
    setLoading(true); setError(''); setStudents([]);
    api('get', '/students', undefined, { params: { search: debounced, page, limit: 50 }, signal: controller.signal })
      .then(res => { setStudents(res.data.data); setHasMore(res.data.hasMore); })
      .catch(err => { if (!axios.isCancel(err)) { setStudents([]); setError(errorMessage(err)); } })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [debounced, page, disabled, accessKey]);
  const hasSelected = students.some(s => s.student_id === value);
  return <div className="toets-student-choice">
    {!disabled && <input className="form-control mb-2" aria-label="Zoek een leerling voor de keuzelijst" placeholder="Zoek op leerlingnaam…"
      value={search} maxLength={200} onChange={e => { setLocalSearch(e.target.value); if (onSearchChange) onSearchChange(e.target.value); }} />}
    <select id={id} className="form-select" value={value} required={required} disabled={disabled}
      onChange={e => onChange(e.target.value, students.find(s => s.student_id === e.target.value)?.student_name || '')}>
      <option value="">{required ? 'Kies een leerling' : allLabel}</option>
      {value && !hasSelected && <option value={value}>{selectedName || 'Geselecteerde leerling'}</option>}
      {students.map(s => <option key={s.student_id} value={s.student_id}>{s.student_name}</option>)}
    </select>
    {loading && <small role="status">Leerlingen laden…</small>}
    {error && <div className="text-danger" role="alert">{error}</div>}
    {!disabled && (page > 1 || hasMore) && <div className="d-flex gap-2 align-items-center mt-2">
      <button type="button" className="btn btn-sm btn-outline-secondary" disabled={page === 1 || loading} onClick={() => setPage(p => p - 1)}>Vorige leerlingen</button>
      <small>{page}</small><button type="button" className="btn btn-sm btn-outline-secondary" disabled={!hasMore || loading} onClick={() => setPage(p => p + 1)}>Meer leerlingen</button>
    </div>}
  </div>;
}
